import { createContext, useContext, useState, type FC } from 'react';

export type SideNavContextType = {
    isExpanded: boolean;
    setExpandedState: React.Dispatch<React.SetStateAction<boolean>>;
    showMobileMenu: boolean;
    setShowMobileMenu: React.Dispatch<React.SetStateAction<boolean>>;
};

export const SideNavContext = createContext<SideNavContextType>({
    isExpanded: false,
    setExpandedState: () => {},
    showMobileMenu: false,
    setShowMobileMenu: () => {}
});

export const useSideNavContext = (): SideNavContextType => useContext(SideNavContext);

export const SideNavContextProvider: FC = ({ children }) => {
    const [isExpanded, setExpandedState] = useState(window.innerWidth > 1024);
    const [showMobileMenu, setShowMobileMenu] = useState(true);

    return (
        <SideNavContext.Provider value={{ isExpanded, setExpandedState, showMobileMenu, setShowMobileMenu }}>
            {children}
        </SideNavContext.Provider>
    );
};
